import { render } from "./ClipboardCopy.vue?vue&type=template&id=e57faa92&scoped=true"
import script from "./ClipboardCopy.vue?vue&type=script&lang=js"
export * from "./ClipboardCopy.vue?vue&type=script&lang=js"

import "./ClipboardCopy.vue?vue&type=style&index=0&id=e57faa92&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e57faa92"]])

export default __exports__